import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from 'react-query';
import * as Sentry from '@sentry/browser';

import { FeatureFlagsProvider } from 'components/feature-flags/index';
import * as config from './config';
import App from './App';
import Footer from './components/Footer/index';

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@janus.team/janus-particles/dist/particles.css';
import '@janus.team/janus-copilot/esm/janus-copilot.css';

import './index.css';
import './index.scss';

const environment = process.env.REACT_APP_ENVIRONMENT || 'local';
// https://app.datadoghq.com/rum/explorer?query=service%3Agcp-ui

if (environment !== 'local') {
  window.DD_RUM.onReady(() => {
    window.DD_RUM.init({
      applicationId: 'e78f4c94-a3a5-4952-8180-508d01e65ed5',
      clientToken: 'pubf9d6add98420230b3ab150ec6840a5f2',
      site: 'datadoghq.com',
      service: 'gcp-ui',
      env: environment,
      version: process.env.REACT_APP_SHA || 'local',
      sampleRate: 100,
      sessionReplaySampleRate: 100, // if not included, the default is 100
      trackResources: true,
      trackLongTasks: true,
      trackInteractions: true,
    });
  });
}

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_PUBLIC_DSN,
  release: process.env.REACT_APP_SHA || 'local',
  debug: process.env.REACT_APP_SENTRY_DEBUG,
  environment: process.env.REACT_APP_ENVIRONMENT || 'local',
  denyUrls: [/local\.dev\.manage\.rackspace\.com/],
  attachStacktrace: true,
});

const queryClient = new QueryClient(config.queryCache());

const basename = () => ((fromConfig) => (
  (`${window.location.href}`.indexOf(fromConfig) >= 0) ? fromConfig : '/gcp'
))(process.env.REACT_APP_ROUTER_BASENAME || '');

const Root = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename={basename()}>
      <FeatureFlagsProvider>
        <App />
        <Footer />
      </FeatureFlagsProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

ReactDOM.render((<Root />), document.getElementById('root'));
